import { PayoutMethodsList } from "./components/PayoutMethodsList";

export { PayoutMethodsWidget } from "./components/PayoutMethodsWidget";

export const PayoutMethods = (props) => {
  return <PayoutMethodsList {...props} />;
};
